import { render, staticRenderFns } from "./DocumentCustomerInfo.vue?vue&type=template&id=38b9e5b9&scoped=true&"
import script from "./DocumentCustomerInfo.vue?vue&type=script&lang=js&"
export * from "./DocumentCustomerInfo.vue?vue&type=script&lang=js&"
import style0 from "./DocumentCustomerInfo.vue?vue&type=style&index=0&id=38b9e5b9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38b9e5b9",
  null
  
)

export default component.exports